<template>
  <section class="home-why-container">
    <h2 class="home-title">서베이지가 보유한 패널이 대신 응답해요</h2>
    <p class="home-sub-title">응답자를 구하러 다니는 대신 조건만 고르면 돼요. 나머지는 서베이지가 해요.</p>

    <div class="why-grid">
      <div class="why-card" v-for="(item, idx) in reasonList" :key="idx">
        <span class="why-icon" v-html="item.icon" aria-hidden="true"></span>
        <div class="why-title">{{ item.title }}</div>
        <p class="why-desc">{{ item.desc }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeWhySurveasy',

  data() {
    return {
      reasonList: [
        {
          title: '논스톱 업로드',
          desc: '쓰던 설문 링크만 붙여넣으면 3분 안에 주문이 끝나요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/></svg>'
        },
        {
          title: '빠른 응답 확보',
          desc: '패널에게 바로 전달돼요. 평균 18시간 안에 목표 응답 수를 채워요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8Z"/></svg>'
        },
        {
          title: '어떤 폼이든 OK',
          desc: '구글폼, 모아폼, Typeform, Qualtrics 등 어떤 링크든 가능해요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>'
        },
        {
          title: '원하는 설문 대상 타겟',
          desc: '연령대와 성별로 응답자를 지정할 수 있어요. 조건은 주문할 때 바로 골라요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>'
        },
        {
          title: '불량 응답은 검수 후 제외',
          desc: '수집이 끝나면 응답 품질을 확인하고 부족분은 부분 환불해요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2 4 5v6c0 5.25 3.4 9.74 8 11 4.6-1.26 8-5.75 8-11V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg>'
        },
        {
          title: '대학(원)생 할인 가격',
          desc: '대학생은 일반 가격의 60%, 대학원생은 80%로 주문할 수 있어요.',
          icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"/><path d="M18.09 10.37A6 6 0 1 1 10.34 18"/><path d="M7 6h1v4"/><path d="m16.71 13.88.7.71-2.82 2.82"/></svg>'
        }
      ]
    }
  }
}
</script>

<style scoped>
.home-why-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
  background-color: var(--white);
}

.home-title {
  margin: 0 0 var(--space-3) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.home-sub-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 17px;
  color: var(--text-muted);
  text-align: left;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.why-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-6);
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  text-align: left;
}

.why-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  background-color: var(--green-50);
  color: var(--green-500);
}

.why-icon svg {
  width: 20px;
  height: 20px;
}

.why-title {
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-heading);
}

.why-desc {
  margin: 0;
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.6;
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .why-grid {
    grid-template-columns: 1fr;
  }
}
</style>
